<tyl-radio-group #control 
    [label]='label'
    [(selected)]='_value'
    (change)="valueChangeHandler()"
    [values]="values"
    [labels]="labels"
    [ids]="ids"
    arrange='vertical' 
    [required]='required'
    [disabled]="disabled">
</tyl-radio-group>